import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { AiResponderSettingsComponent } from './ai-responder-settings.component'
import { take } from 'rxjs/operators'

@Injectable()
export class AIResponderSettingsService {
  constructor(private dialog: MatDialog) {}

  public open() {
    const defaultConfig: MatDialogConfig = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data: {},
      panelClass: ['modal', 'side-modal-lg', 'modal-owner-details', 'right'],
    }

    const dialogRef = this.dialog.open(AiResponderSettingsComponent, defaultConfig)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }
}
